export default __webpack_public_path__ + "static/media/management-256x256.5565f328.png";